// 围栏报警
const platformFence = (resolve) => {
  import('components/platform/platform.fenceAlarm').then((module) => {
    resolve(module)
  })
}
// 关键点
const platformKeypoint = (resolve) => {
  import('components/platform/platform.keyPoint').then((module) => {
    resolve(module)
  })
}
// 路线偏移
const platformRouteDeviation = (resolve) => {
  import('components/platform/platform.routeDeviation').then((module) => {
    resolve(module)
  })
}
// WiFi下载
const platformWifi = (resolve) => {
  import('components/platform/platform.wifiDownload').then((module) => {
    resolve(module)
  })
}
// 抓拍计划
const platformSnap = (resolve) => {
  import('components/platform/platform.snapshotplan').then((module) => {
    resolve(module)
  })
}
// 报警联动
const platformAlarm = (resolve) => {
  import('components/platform/platform.alarmaction').then((module) => {
    resolve(module)
  })
}
// 维修管理
const platformMaintain = (resolve) => {
  import('components/platform/platform.maintainManage').then((module) => {
    resolve(module)
  })
}
// 录像计划
const platformRecord = (resolve) => {
  import('components/platform/platform.recordPlan').then((module) => {
    resolve(module)
  })
}
// 存储配置
const platformStorageConfig = (resolve) => {
  import('components/platform/platform.storageConfig').then((module) => {
    resolve(module)
  })
}
// 离线升级计划
const offlineUpgrade = (resolve) => {
  import('components/platform/platform.offlineUpgrade').then((module) => {
    resolve(module)
  })
}
// 文本下发
const textDelivery = (resolve) => {
  import('components/platform/platform.textDelivery').then((module) => {
    resolve(module)
  })
}
// 车辆运营状态报备
const deviceoperation = (resolve) => {
  import('components/platform/platform.deviceoperation').then((module) => {
    resolve(module)
  })
}
// 文件列表
const fileList = (resolve) => {
  import('components/operation/operation.file').then((module) => {
    resolve(module)
  })
}
// 广告列表
const advertiseList = (resolve) => {
  import('components/operation/operation.advertise').then((module) => {
    resolve(module)
  })
}
// 设备文件列表
const fileDevice = (resolve) => {
  import('components/operation/operation.fileDevice').then((module) => {
    resolve(module)
  })
}
// 设备广告列表
const advertiseDevice = (resolve) => {
  import('components/operation/operation.advertiseDevice').then((module) => {
    resolve(module)
  })
}
// 设备广告列表
const advertiseDevicePermit = (resolve) => {
  import('components/operation/operation.advertiseDevicePermit').then((module) => {
    resolve(module)
  })
}
const platformRouter = {
  platformPath: [{
    path: '/platform/fence', // 围栏报警
    component: platformFence
  },
  {
    path: '/platform/keyPoint', // 关键点
    component: platformKeypoint
  },
  {
    path: '/platform/routeDeviation', // 路线偏移
    component: platformRouteDeviation
  },
  {
    path: '/platform/wifi', // WiFi下载
    component: platformWifi
  },
  {
    path: '/platform/snapshotplan', // 抓拍计划
    component: platformSnap
  },
  {
    path: '/platform/alarmaction', // 报警联动
    component: platformAlarm
  },
  {
    path: '/platform/maintainManage', // 维修管理
    component: platformMaintain
  },
  {
    path: '/platform/recordPlan', // 录像计划
    component: platformRecord
  },
  {
    path: '/platform/storageConfig', // 存储配置
    component: platformStorageConfig
  },
  {
    path: '/platform/offlineUpgrade', // 离线升级计划
    component: offlineUpgrade
  },
  {
    path: '/platform/textDelivery', // 文本下发
    component: textDelivery
  },
  {
    path: '/platform/deviceoperation', // 车辆运营状态报备
    component: deviceoperation
  },
  {
    path: '/platform/fileList', // 文件列表
    component: fileList
  },
  {
    path: '/platform/advertiseList', // 广告列表
    component: advertiseList
  },
  {
    path: '/platform/fileDevice', // 设备文件列表
    component: fileDevice
  },
  {
    path: '/platform/advertiseDevice', // 设备广告列表
    component: advertiseDevice
  },
  {
    path: '/platform/advertiseDevicePermit', // 设备广告列表
    component: advertiseDevicePermit
  }
  ]
}

export default platformRouter



// WEBPACK FOOTER //
// ./src/router/platform.js